import React, { useMemo, useRef, useState } from 'react';
import './JoinPage.css';
import { Link } from 'react-router-dom';

const tabs = [
  { id: 'personal', name: '个人入驻' },
  { id: 'self', name: '个体入驻' },
  { id: 'enterprise', name: '企业入驻' },
];

const phoneReg = /^1[3-9][0-9]{9}$/;
const idReg = /^(\d{15}|\d{17}[\dXx])$/;
const MAX_SIZE = 5 * 1024 * 1024; // 5MB

// 用户协议内容
const AGREEMENT_CONTENT = `益美科技家政服务平台商家入驻协议

一、协议主体
甲方（平台方）： 益美科技家政服务平台（www.xinfeich.com）
乙方（入驻商户）： 提供家政服务的合法企业或个体工商户或个人服务主体

二、入驻资质与要求

商户资质

• 需提供营业执照、法人身份证、银行账户信息（对公/对私）。
• 个体工商户需额外提交经营者身份证明。
• 特殊工种（如保洁、月嫂）需提供职业资格证或健康证明。

服务合规性

• 禁止虚假宣传、超范围经营或提供违法服务（如高空作业无资质）。

三、平台运营规范

商品与服务管理

• 乙方需明确标注服务内容、价格、时长及退款规则（例如：3小时基础保洁￥120，取消订单需提前2小时通知）。
• 禁止私自引导用户线下交易，违者冻结账户并扣罚保证金。

用户评价与投诉

• 乙方需48小时内响应用户投诉，差评率超过15%将暂停服务资格。

平台抽成与费用

• 平台佣金率为交易额的10%（含支付通道费），按月结算。

四、交易规则与资金结算

支付流程

• 用户支付款项暂存平台担保账户，服务完成且用户确认后，资金T+1结算至乙方账户。

分账机制

• 支持多角色分账（如：平台抽成10%，服务人员分账90%），需提前在后台配置分账比例。

退款与争议处理

• 服务未完成时，用户可申请全额退款；争议订单由平台仲裁，仲裁结果双方需无条件执行。

五、数据与隐私保护
• 乙方不得泄露用户信息（如住址、联系方式），违者承担法律责任。
• 平台有权使用订单数据优化服务，但需匿名化处理。

六、协议终止与违约责任
• 合作期限：1年，自动续约。
• 退出机制：乙方需提前30日申请，并结清所有订单款项。
• 违约处罚：
  • 刷单、欺诈等行为扣罚全部保证金（默认￥5000元）并终止合作。

七、附则
• 本协议未尽事宜参照《微信支付服务商协议》及《电子商务法》执行。
• 争议解决：协商不成，提交甲方所在地（杭州）人民法院诉讼。

附件：
• 《家政服务安全操作规范》
• 《反洗钱承诺书》

注：协议需由法务审核后签署，乙方入驻时需同步上传资质文件至平台后台。


附件1：
家政服务安全操作规范（2025年修订版）

一、总则
1. 适用范围
2. 本规范适用于平台入驻商户提供的所有家政服务，包括但不限于保洁、月嫂、整理收纳、家电清洗等。
3. 安全原则
   服务全程需遵循"预防为主、安全第一"原则，保障客户、服务人员及第三方人身财产安全。

二、服务人员安全要求
1. 资质与健康
   需持有效健康证、职业资格证（如母婴护理、高空作业等特殊工种）。
   服务前需自查体温及健康状况，禁止带病作业。
2. 个人防护
   保洁人员需穿戴防滑鞋、手套、口罩；高空作业须系安全带并使用防坠设备。

三、服务过程安全规范
1. 入户安全
   入户前需向平台报备，全程佩戴平台工牌并录音存档（需客户知情同意）。
   严禁单独进入异性客户卧室或私密空间，特殊情况需第三方见证。
2. 操作安全
   清洁剂使用：严格按稀释比例调配，禁止混用化学药剂（如84消毒液与洁厕灵）。
   电器操作：断电后清洁家电，禁止湿手接触电源。
   高空作业：2米以上作业需两人配合，使用平台认证的伸缩梯及防护绳。

四、应急处理
1. 事故预案
   服务人员须掌握急救技能（如止血、烫伤处理），随身携带应急包（含创可贴、消毒棉片等）。
2. 突发事件
   遇火灾、漏电等立即中止服务，疏散人员并拨打119/120，同步联系平台客服。

五、客户隐私与数据安全
1. 信息保密
   禁止拍摄、传播客户住宅内部影像或泄露住址、联系方式。
2. 数据管理
   服务记录需加密上传至平台，纸质单据当日销毁。

六、监督与改进
1. 违规处罚
   违反安全规范者，平台将冻结账户并扣罚保证金（情节严重者移交司法机关）。
2. 持续优化
   每季度组织安全培训，更新规范内容。

附件：
《家政服务安全自查表》（含工具消毒、防护检查等条目）
每月收集服务人员操作反馈及客户安全建议，结合典型安全案例对自查表条目进行动态调整，确保覆盖新兴服务场景中的潜在风险。同时，平台将定期组织自查表使用培训，通过模拟操作考核强化服务人员对安全检查要点的掌握，推动安全规范从纸面要求转化为日常服务中的自觉行动。

此外，建立安全规范执行的量化评估机制，依据自查表的检查结果对服务人员进行评分。对于评分较高的人员给予奖励，如额外的平台流量支持、优先派单等，激励服务人员主动遵循安全规范。同时，针对评分较低的人员，安排一对一的辅导和再培训，帮助其弥补安全操作上的短板。

在技术层面，引入智能化安全管理系统，将自查表电子化，服务人员可通过手机端便捷操作，系统能实时记录和分析检查数据，自动生成安全报告。平台依据报告中的数据趋势，提前预警可能出现的安全问题，及时调整安全规范和培训重点。

并且，鼓励服务人员之间开展安全经验交流活动，每季度举办一次安全分享会，邀请安全操作表现优秀的人员分享实际案例和应对技巧。通过这种方式，促进服务人员之间的相互学习，形成良好的安全文化氛围，共同提升家政服务的安全水平。

为了进一步强化安全规范的落地效果，与权威的家政行业研究机构建立合作关系。定期邀请专家对平台的安全操作规范进行评估和指导，参考行业最新的安全标准和研究成果，确保平台的安全规范始终处于行业领先水平。

同时，将安全规范纳入服务人员的职业发展体系。在服务人员的晋升、评级考核中，安全操作表现作为重要的考核指标之一。这不仅能够激励服务人员长期保持良好的安全操作习惯，还能在平台内部形成积极向上的安全工作导向。

在对外宣传方面，将平台严格的安全操作规范作为重要的宣传点，向客户展示平台对服务安全的高度重视。通过线上线下的宣传渠道，如平台网站、社交媒体、社区活动等，让更多的客户了解平台的安全保障措施，增强客户对平台的信任度和认同感。

另外，建立安全举报机制，鼓励服务人员和客户对违反安全规范的行为进行举报。对于核实的举报，给予举报人一定的奖励，同时对违规者进行严肃处理。通过这种方式，形成全员参与安全管理的良好局面，共同维护家政服务的安全环境。

最后，持续关注国家相关政策法规的变化和行业动态。当有新的安全法规出台或行业标准更新时，及时对平台的安全操作规范进行调整和完善，确保平台始终合法合规运营，为客户提供安全、可靠的家政服务。

为使安全规范的持续优化工作更具针对性和前瞻性，平台将建立行业安全风险数据库。收集家政服务行业内各类安全事故案例，按照事故类型、发生场景、影响因素等进行分类整理。服务人员在日常工作中若遇到潜在安全风险或异常情况，可通过平台移动端及时上报，补充数据库信息。

基于这个数据库，利用大数据分析技术，挖掘安全事故的潜在规律和发展趋势。例如，分析在不同季节、不同地区家政服务中容易出现的安全问题，预测未来可能面临的安全挑战。根据这些分析结果，提前调整安全操作规范和培训内容，做到未雨绸缪。

平台还将与保险机构合作，定制专门的家政服务安全保险产品。根据服务内容、安全风险等级等因素，为服务人员和客户提供多样化的保险方案。这既能在发生安全事故时为各方提供经济保障，降低损失，又能促使服务人员更加重视安全操作，因为安全意识和操作水平与保险费率挂钩。

在安全文化建设方面，开展安全主题月活动。每个季度设定一个安全主题，如"电器使用安全月""高空作业安全月"等。在活动期间，通过线上直播、短视频、知识竞赛等形式，向服务人员和客户普及相关安全知识和操作要点。同时，在平台上展示安全操作模范的事迹和经验，树立正面榜样，营造浓厚的安全文化氛围。

并且，与其他家政服务平台建立安全信息共享机制。定期交流安全管理经验、典型事故案例和安全规范更新情况。通过这种合作，整合行业资源，共同提升整个家政服务行业的安全水平，为行业的健康发展贡献力量。

《应急联络表》（平台客服、就近医院、消防站联系方式）
应定期根据区域内医疗机构、消防救援站点的最新信息进行更新，确保联系方式的准确性和有效性。同时，将该联络表整合至平台服务人员的移动端工作助手，设置一键呼叫功能，以便在紧急情况下能快速获取援助。此外，平台可通过定期推送测试消息的方式，提醒服务人员熟悉联络表的使用路径，避免因紧急时刻的慌乱而延误求助时机。

在持续优化《应急联络表》的过程中，还可以考虑增加一些特殊机构的联系方式，比如当地的家政服务行业协会、法律援助中心等。当遇到一些复杂的事故纠纷，或者涉及到服务人员和客户法律权益的问题时，这些机构能够提供专业的指导和支持。

为了让服务人员更直观便捷地使用《应急联络表》，可以将其制作成卡片形式，印刷并发放到每个服务人员手中。卡片上除了清晰列出各类紧急联系电话外，还可以配上简单的文字说明，告知在何种情况下应该拨打哪个电话。

另外，平台应建立一个反馈机制，鼓励服务人员在实际使用《应急联络表》过程中，提出关于联络表内容、格式、使用便利性等方面的意见和建议。根据这些反馈，及时调整和完善《应急联络表》，使其更好地满足实际应急需求。

同时，随着科技的发展和社会资源的动态变化，平台要密切关注周边应急资源的分布和调整情况。例如，若有新的急救中心投入使用，或者消防站的管辖区域发生变更，要迅速更新《应急联络表》中的相关信息，确保其始终具有实用性和时效性。

还可以结合大数据分析，对以往应急事件中联络表的使用情况进行深入研究。分析哪些联系方式被频繁使用，哪些使用频率较低，从而合理优化联络表的内容结构，突出重点紧急联络信息，提高服务人员在紧急状况下获取有效帮助的效率。

除了上述的优化举措，平台还可以针对《应急联络表》开展专项培训活动。定期组织服务人员参加应急联络表使用的培训课程，通过模拟应急场景演练，让服务人员熟练掌握在不同事故类型下如何快速准确地从联络表中获取所需的联系方式，并正确拨打求助电话。培训过程中，详细讲解每个紧急联络对象的职责和服务范围，使服务人员能够在紧急时刻清晰判断应该向谁求助。

为了增强服务人员对应急联络表的重视程度，可以将对《应急联络表》的熟悉和使用情况纳入服务人员的绩效考核体系。设置相应的考核指标，如是否能在规定时间内准确说出重要紧急联络电话、是否在模拟演练中正确使用联络表等。对于考核成绩优秀的服务人员给予适当的奖励，激励他们积极学习和掌握应急联络表的相关知识。

在技术层面，平台可以开发一个智能应急提醒系统，与《应急联络表》进行关联。当服务人员在工作过程中触发某些特定的危险信号时，系统会自动弹出应急联络表，并根据危险类型高亮显示推荐的联络方式。例如，当检测到服务人员可能遭遇电气火灾时，系统会自动突出显示消防站的联系方式，并提供简单的火灾应急处理提示。

此外，平台还可以与应急联络表中的相关机构建立长期稳定的合作关系。定期与医院、消防站等单位沟通交流，了解他们的最新服务流程和要求，同时向他们反馈服务人员在使用联络表过程中遇到的问题和建议。通过这种合作，不断优化应急响应流程，提高应急救援的效率和质量，为家政服务的安全提供更加坚实的保障。


附件二：
益美科技家政服务平台反洗钱承诺书

甲方（平台方）： 益美科技家政服务平台（www.xinfeich.com）
乙方（入驻商户）： 家政服务提供方（企业/个体工商户/个人）

一、承诺主体
乙方承诺严格遵守《中华人民共和国反洗钱法》《非银行支付机构反洗钱和反恐怖融资管理办法》等法律法规，配合甲方履行反洗钱义务。

二、核心承诺内容
身份核验义务
a. 提供真实有效的营业执照、法人身份证及银行账户信息，若信息变更需3日内更新至甲方平台。
b. 对单笔交易金额≥1万元或月累计≥5万元的订单，需留存服务合同及客户身份证明备查。

交易监控与报告
a. 禁止通过拆分订单（如将1万元服务拆分为10笔千元订单）规避监管。
b. 发现可疑交易（如客户要求现金支付、拒绝提供服务凭证等）需24小时内向甲方风控部门报备。

数据安全
a. 不得将用户支付信息、服务地址等数据用于非平台业务，离职人员需签署脱密协议。

三、违约责任
乙方违反承诺导致甲方被监管处罚的，需承担全部罚款及律师费用。
甲方有权冻结乙方账户资金直至调查结束，情节严重者终止合作并列入行业黑名单。

签署栏：
乙方（签字）：____`;

const JoinPage = () => {
  const [active, setActive] = useState('personal');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [form, setForm] = useState({
    name: '',
    idNo: '',
    phone: '',
    address: '',
    bankNo: '',
    bankName: '',
    accountName: '',
    companyName: '',
    companyAddress: '',
  });

  const [uploads, setUploads] = useState({
    idFront: { file: null, preview: '', error: '' },
    idBack: { file: null, preview: '', error: '' },
    license: { file: null, preview: '', error: '' },
  });

  const fileInputsRef = useRef({});

  const showLicense = useMemo(() => active !== 'personal', [active]);
  const showEnterprise = useMemo(() => active === 'enterprise', [active]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const setUploadState = (key, patch) => {
    setUploads((prev) => ({ ...prev, [key]: { ...prev[key], ...patch } }));
  };

  const pickFile = (key) => {
    const input = fileInputsRef.current[key];
    if (input) input.click();
  };

  const validateImage = (file) => {
    if (!file) return '未选择文件';
    if (!file.type.startsWith('image/')) return '仅支持图片文件（jpg/png/webp等）';
    if (file.size > MAX_SIZE) return '文件大小不能超过 5MB';
    return '';
  };

  const handleFiles = (key, file) => {
    const err = validateImage(file);
    if (err) {
      setUploadState(key, { error: err, file: null, preview: '' });
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      setUploadState(key, { file, preview: e.target.result, error: '' });
    };
    reader.readAsDataURL(file);
  };

  const onFileChange = (key, e) => {
    const file = e.target.files && e.target.files[0];
    if (file) handleFiles(key, file);
  };

  const onDrop = (key, e) => {
    e.preventDefault();
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) handleFiles(key, file);
  };

  const removeFile = (key) => setUploadState(key, { file: null, preview: '', error: '' });

  // 处理键盘事件（ESC关闭模态框）
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && showAgreementModal) {
      setShowAgreementModal(false);
    }
  };

  // 添加键盘事件监听
  React.useEffect(() => {
    if (showAgreementModal) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [showAgreementModal]);

  const validate = () => {
    if (!form.name.trim()) return '请输入姓名';
    if (!idReg.test(form.idNo)) return '请输入正确的身份证号';
    if (!phoneReg.test(form.phone)) return '请输入正确的手机号';
    if (!form.address.trim()) return '请输入地址';
    if (showEnterprise) {
      if (!form.bankNo.trim()) return '请输入银行卡号码';
      if (!form.bankName.trim()) return '请输入开户行';
      if (!form.accountName.trim()) return '请输入户名';
      if (!form.companyName.trim()) return '请输入公司名字';
      if (!form.companyAddress.trim()) return '请输入公司地址';
    }
    // 上传错误提示优先
    if (uploads.idFront.error || uploads.idBack.error || uploads.license.error) {
      return uploads.idFront.error || uploads.idBack.error || uploads.license.error;
    }
    // 协议验证
    if (!agreeToTerms) return '请先阅读并同意《益美科技家政服务平台商家入驻协议》';
    return '';
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return alert(err);
    setIsSubmitting(true);
    // 控制台输出已选择的文件信息（模拟上传）
    console.log('Join submit:', { active, form, uploads: {
      idFront: uploads.idFront.file,
      idBack: uploads.idBack.file,
      license: uploads.license.file,
    }});
    await new Promise((r) => setTimeout(r, 800));
    setIsSubmitting(false);
    alert('提交成功，正在审核中');
  };

  const UploadField = ({ label, name }) => {
    const data = uploads[name] || { file: null, preview: '', error: '' };
    const [dragOver, setDragOver] = useState(false);
    return (
      <div className="form-group">
        <label>{label}</label>
        <div
          className={`upload-box ${data.preview ? 'has-file' : ''} ${dragOver ? 'drag' : ''}`}
          role="button"
          tabIndex={0}
          onClick={() => pickFile(name)}
          onKeyDown={(e) => e.key === 'Enter' && pickFile(name)}
          onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={(e) => { setDragOver(false); onDrop(name, e); }}
          aria-label={`上传${label}`}
        >
          {!data.preview ? (
            <div className="upload-placeholder">
              <div className="upload-icon">⬆️</div>
              <div className="upload-text">点击或拖拽图片到此处（≤5MB，jpg/png/webp）</div>
            </div>
          ) : (
            <div className="upload-preview">
              <div className="upload-thumb"><img src={data.preview} alt={label} /></div>
              <div className="upload-meta">
                <div className="file-name" title={data.file?.name}>{data.file?.name || ''}</div>
                <div className="upload-actions">
                  <button type="button" className="btn-mini" onClick={() => pickFile(name)}>重新选择</button>
                  <button type="button" className="btn-mini danger" onClick={() => removeFile(name)}>删除</button>
                </div>
              </div>
            </div>
          )}
          {data.error ? <div className="upload-error">{data.error}</div> : null}
          <input
            ref={(el) => (fileInputsRef.current[name] = el)}
            type="file"
            accept="image/*"
            className="hidden-file-input"
            onChange={(e) => onFileChange(name, e)}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="join-page">
      <header className="join-header">
        <Link to="/" className="back-btn">← 返回</Link>
        <h1>入驻中心</h1>
      </header>

      <div className="container">
        <div className="tabs">
          {tabs.map((t) => (
            <button key={t.id} className={`tab ${active === t.id ? 'active' : ''}`} onClick={() => setActive(t.id)}>
              {t.name}
            </button>
          ))}
        </div>

        <form className="join-form" onSubmit={onSubmit}>
        {/* 分组：基础信息 */}
        <section className="group">
          <div className="section-title">基础信息</div>
          <div className="grid">
            <div className="form-group">
              <label>姓名 *</label>
              <input type="text" name="name" value={form.name} onChange={onChange} placeholder="请输入" required />
            </div>
            <div className="form-group">
              <label>身份证号 *</label>
              <input type="text" name="idNo" value={form.idNo} onChange={onChange} placeholder="请输入" required />
            </div>
            <div className="form-group">
              <label>手机号码 *</label>
              <input type="tel" name="phone" value={form.phone} onChange={onChange} placeholder="请输入" required />
            </div>
            <div className="form-group full">
              <label>地址 *</label>
              <textarea name="address" value={form.address} onChange={onChange} placeholder="请输入详细地址" rows="3" required />
            </div>
          </div>
        </section>

        {/* 分组：证件上传 */}
        <section className="group">
          <div className="section-title">证件上传</div>
          <div className="grid">
            <UploadField label="身份证正面" name="idFront" />
            <UploadField label="身份证反面" name="idBack" />
            {showLicense && (<UploadField label="营业执照" name="license" />)}
          </div>
        </section>

        {/* 分组：企业信息（企业入驻时显示） */}
        {showEnterprise && (
          <section className="group">
            <div className="section-title">企业信息</div>
            <div className="grid">
              <div className="form-group">
                <label>银行卡号码 *</label>
                <input type="text" name="bankNo" value={form.bankNo} onChange={onChange} placeholder="请输入" required />
              </div>
              <div className="form-group">
                <label>开户行 *</label>
                <input type="text" name="bankName" value={form.bankName} onChange={onChange} placeholder="请输入" required />
              </div>
              <div className="form-group">
                <label>户名 *</label>
                <input type="text" name="accountName" value={form.accountName} onChange={onChange} placeholder="请输入" required />
              </div>
              <div className="form-group">
                <label>公司名字 *</label>
                <input type="text" name="companyName" value={form.companyName} onChange={onChange} placeholder="请输入" required />
              </div>
              <div className="form-group full">
                <label>公司地址 *</label>
                <textarea name="companyAddress" value={form.companyAddress} onChange={onChange} placeholder="请输入公司地址" rows="3" required />
              </div>
            </div>
          </section>
        )}

        {/* 用户协议勾选区域 */}
        <div className="agreement-section">
          <label className="agreement-checkbox">
            <input
              type="checkbox"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
            />
            <span className="checkmark"></span>
            <span className="agreement-text">
              我已签字并同意入驻协议
              <button
                type="button"
                className="agreement-link"
                onClick={() => setShowAgreementModal(true)}
              >
                《益美科技家政服务平台商家入驻协议》
              </button>
            </span>
          </label>
        </div>

        <button type="submit" className="submit-btn" disabled={isSubmitting || !agreeToTerms}>
          {isSubmitting ? '提交中...' : '提交'}
        </button>
        </form>
      </div>

      {/* 用户协议模态框 */}
      {showAgreementModal && (
        <div className="modal-overlay" onClick={() => setShowAgreementModal(false)}>
          <div className="modal-content agreement-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>益美科技家政服务平台商家入驻协议</h2>
              <button
                className="modal-close"
                onClick={() => setShowAgreementModal(false)}
                aria-label="关闭"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="agreement-content">
                {AGREEMENT_CONTENT.split('\n').map((line, index) => (
                  <p key={index} className={line.trim() === '' ? 'empty-line' : ''}>
                    {line}
                  </p>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn modal-btn"
                onClick={() => setShowAgreementModal(false)}
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JoinPage;


